const apiAddress = 'https://phe-api.madtechet.com';

const constants = {
  apiAddress,
  apiUrl: `${apiAddress}/api`,
  mediaUrl: `${apiAddress}/media`,
  authUrl: 'auth-phe24',
  keys: {
    user: 'user',
  },
  prefixes: {
    sorting: 'sorting',
    visibility: 'visibility',
    density: 'density',
    rowsPerPage: 'rows_per_page',
  },
};

export default constants;
